import { Box } from '@zoopla-eng/zds/box';
import { Select } from '@zoopla-eng/zds/select';
import { Stack } from '@zoopla-eng/zds/stack';
import type { Option } from './options';
import { lastSoldOptions, propertyTypeOptions, sortOptions } from './options';
import { itemStyle } from './Filters.styles.css';

type FilterProps = {
    handleLastSoldOptionChange: (option: Option) => void;
    selectedLastSoldOption: Option;
    handlePropertyTypeOptionsChange: (option: Option) => void;
    selectedPropertyTypeOption: Option;
    handleSortOptionChange: (option: Option) => void;
    selectedSortOption: Option;
};

const Filters = (props: FilterProps) => {
    const {
        handleLastSoldOptionChange,
        selectedLastSoldOption,
        handlePropertyTypeOptionsChange,
        selectedPropertyTypeOption,
        handleSortOptionChange,
        selectedSortOption
    } = props;

    return (
        <Box pb="S500">
            <Stack flexDirection="row" columnGap="S400" rowGap="S400">
                <div className={itemStyle}>
                    <Select
                        options={lastSoldOptions}
                        label="Last sold within"
                        onSelectedOptionChange={handleLastSoldOptionChange}
                        selectedOption={selectedLastSoldOption}
                    />
                </div>
                <div className={itemStyle}>
                    <Select
                        options={propertyTypeOptions}
                        label="Property type"
                        onSelectedOptionChange={handlePropertyTypeOptionsChange}
                        selectedOption={selectedPropertyTypeOption}
                    />
                </div>
                <div className={itemStyle}>
                    <Select
                        options={sortOptions}
                        label="Sort"
                        onSelectedOptionChange={handleSortOptionChange}
                        selectedOption={selectedSortOption}
                    />
                </div>
            </Stack>
        </Box>
    );
};

export default Filters;
